import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal';
import NotLoggedBlock from '../../login/NotLoggedBlock';
import OAuthNotLoggedInBlock from '../../login/OAuthNotLoggedInBlock';
import HttpController from '../../controllers/HttpController';
import ViewUtil from '../../ViewUtil';
import AuthMechanism, { AuthRealm } from '../../auth/AuthMechanism';

import './LoginModal.css';
import t from '../../i18n/I18n';

class LoginModal extends React.Component {
  static propTypes = {
    onSuccess: PropTypes.func,
    onError: PropTypes.func
  };

  state = {
    show: true,
    authMechanism: null
  };

  componentDidMount() {
    HttpController.pauseHttpOperations = true;
    document.querySelector('.modal-background').addEventListener('click', this.onBackgroundClick, true);
    setTimeout(() => {
      const input = document.querySelector('[name="NotLoggedBlock"] input');
      if (input && input.focus) {
        input.focus();
      }
    }, 250);
  }

  componentWillUnmount() {
    HttpController.pauseHttpOperations = false;
    const objectRef = document.querySelector('.modal-background');
    if (objectRef) objectRef.removeEventListener('click', this.onBackgroundClick, true);
  }

  onBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      e.stopPropagation();
    }
  };

  onSignInComplete = (err) => {
    const { onSuccess, onError } = this.props;
    if (err) {
      return onError(err);
    }

    onSuccess(true, this);
  };

  hide = () => {
    document.querySelector('.modal-background').removeEventListener('click', this.onBackgroundClick, true);
    this.setState({ show: false });
  };

  onAuthMechanismChange = (authMechanism: AuthMechanism): void => {
    this.setState({ authMechanism: authMechanism });
  };

  render() {
    const { onSuccess } = this.props;
    const { show, authMechanism } = this.state;

    if (!show) {
      return null;
    }

    const modalProps = {
      name: 'LoginModal',
      onClose: () => onSuccess(false, this),
      cancelButtonTitle: t('CANCEL'),
      actionButtonTitle: null,
      closeOnOutsideClick: false,
      autoCloseOnAction: false,
      zIndex: 200,
      title: t('COMMENT_REQUIRES_LOGIN')
    };

    const notLoggedProps = {
      backgroundImageStyle: 'none',
      subtitle: 'COMMENT_REQUIRES_LOGIN',
      fullHeight: false,
      toggleSpinner: false,
      resetSessionOnLoginFail: false,
      isLinkUser: ViewUtil.isDirectLinkToCollection() && window.gs.isLogged, //Todo: check why isLogged condition is here?
      onSignInComplete: this.onSignInComplete
    };

    return (
      <Modal {...modalProps} closeOnEsc closeOnOutsideClick> {
        authMechanism === AuthMechanism.OAuth ? (
          <OAuthNotLoggedInBlock onAuthMechanismChange={this.onAuthMechanismChange} {...notLoggedProps}/>
        ) : (
          <NotLoggedBlock onAuthMechanismChange={this.onAuthMechanismChange} {...notLoggedProps}/>
        )
      }
      </Modal>
    );
  }
}

export default LoginModal;
